import { Select } from '@round/creatorbase-ui';
import { postingFrequencyOptions, PostingFrequencyTier } from '../../utils/creatorSearchUtils';
import selectStyles from './selectFilterStyles.module.css';

type Props = {
    value: PostingFrequencyTier | undefined;
    onChange: (value: PostingFrequencyTier | undefined) => void;
};

const anyOption = { label: 'Any', value: 'ANY' };

export const PostingFrequencyFilter = ({ value, onChange }: Props) => {
    return (
        <Select
            className={selectStyles.trigger}
            contentClassName={selectStyles.content}
            options={[anyOption, ...postingFrequencyOptions]}
            value={value}
            onChange={(option) => {
                onChange(option === 'ANY' ? undefined : (option as PostingFrequencyTier));
            }}
            placeholder="Any"
        />
    );
};
